export const numberWithCommas = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};



// WEBPACK FOOTER //
// ./src/utils/numberFormatter.js